import { useCallTimer } from '../../timer/useCallTimer';
import { useTheme } from '@doxyme/ui/theme';
import { BodyS } from '@doxyme/ui/typography';

import type { JSX } from 'react';

type Props = {
  fullWidth?: boolean;
};

export const CALL_TIMER_HEIGHT = 32;
export const CALL_TIMER_VERTICAL_PADDING = 16; // theme.spacing(2) top + bottom

export const CallTimer = ({ fullWidth = false }: Props): JSX.Element => {
  const theme = useTheme();

  const { parts } = useCallTimer();

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: fullWidth ? 'center' : undefined,
        height: CALL_TIMER_HEIGHT,
        backgroundColor: theme.incall.timer.background,
        borderRadius: theme.shape.radius8,
        padding: theme.spacing(0, 2),
        width: fullWidth ? '100%' : undefined,
      }}
    >
      <BodyS
        fontWeight='medium'
        color={theme.text.generic.secondary}
        css={{
          fontVariantNumeric: 'lining-nums tabular-nums',
          whiteSpace: 'nowrap',
          display: 'flex',
          gap: theme.spacing(2),
          justifyContent: fullWidth ? 'center' : undefined,
          width: fullWidth ? '100%' : undefined,
        }}
      >
        {parts.map((part, index) => (
          <span key={index} style={{ display: 'flex', gap: '2px' }}>
            <span>{part.value}</span>
            <span>{part.unit}</span>
          </span>
        ))}
      </BodyS>
    </div>
  );
};
